module.exports = __webpack_public_path__ + "static/img/user-icon.ce761374.png";